import { useRef } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Bold, Heading2, List } from "lucide-react";

export const Markdown = ({ children, className = "" }) => (
  <div className={`prose-ppusa ${className}`} data-testid="markdown-body">
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{children || ""}</ReactMarkdown>
  </div>
);

// Lightweight markdown editor: textarea + a small formatting toolbar.
export const MarkdownEditor = ({ value, onChange, testid = "markdown-editor", rows = 10 }) => {
  const ref = useRef(null);

  const wrap = (before, after = before) => {
    const ta = ref.current;
    if (!ta) return;
    const start = ta.selectionStart, end = ta.selectionEnd;
    const sel = value.slice(start, end) || "text";
    const next = value.slice(0, start) + before + sel + after + value.slice(end);
    onChange(next);
    setTimeout(() => { ta.focus(); ta.selectionStart = start + before.length; ta.selectionEnd = start + before.length + sel.length; }, 0);
  };

  const linePrefix = (prefix) => {
    const ta = ref.current;
    if (!ta) return;
    const start = ta.selectionStart;
    const lineStart = value.lastIndexOf("\n", start - 1) + 1;
    const next = value.slice(0, lineStart) + prefix + value.slice(lineStart);
    onChange(next);
    setTimeout(() => { ta.focus(); ta.selectionStart = ta.selectionEnd = start + prefix.length; }, 0);
  };

  const btn = "inline-flex items-center gap-1 border border-slate-300 px-2.5 py-1.5 text-xs font-semibold text-slate-600 hover:bg-slate-100 hover:text-[#0A1128] transition-colors duration-150";

  return (
    <div>
      <div className="flex gap-2 mb-2 flex-wrap">
        <button type="button" data-testid={`${testid}-h2`} onClick={() => linePrefix("## ")} className={btn}><Heading2 className="w-3.5 h-3.5" /> Heading</button>
        <button type="button" data-testid={`${testid}-bold`} onClick={() => wrap("**")} className={btn}><Bold className="w-3.5 h-3.5" /> Bold</button>
        <button type="button" data-testid={`${testid}-list`} onClick={() => linePrefix("- ")} className={btn}><List className="w-3.5 h-3.5" /> List</button>
      </div>
      <textarea
        ref={ref}
        data-testid={testid}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        placeholder="Write the full division story. Use the buttons above for headings, bold, and lists…"
        className="w-full border border-slate-300 px-4 py-3 rounded-none focus:outline-none focus:border-[#D90429] transition-colors duration-200 font-mono text-sm resize-y"
      />
      <p className="text-xs text-slate-400 mt-1">Supports Markdown: <code>## Heading</code>, <code>**bold**</code>, <code>- list item</code>.</p>
    </div>
  );
};
